mtl.alloy.factory['submit-in-modal'] = (function($, app, util) {
    'use strict';

    return function(element, options) {

        $(element).on('submit', submitAddToCartForm);

    };

    function submitAddToCartForm(e)
    {
        e.preventDefault();

        var $form = $(this);

        $.ajax({
            'url': $form.attr('action'),
            'data': $form.serialize(),
            'method': 'post',
            'success': function(data) {
                $.fancybox({content: data});
            },
            'error': function(jqXhr, textStatus, errorThrown) {
                console.error(textStatus, errorThrown);
            }
        });
    }

}(jQuery, app, util));
